<mwp-card-content-header contentTitleMwp="Execute Reports" />
@if (wizardPanel == reportWizardPanel.initialize) {
  <mwp-report-builder-intialize [reportsList]="reports" (emitSave)="submitPanel($event)" />
}
@if (wizardPanel == reportWizardPanel.company) {
  <mwp-report-builder-company (emitCancel)="reset()" (emitSave)="submitPanel($event)" />
}
@if (wizardPanel == reportWizardPanel.templates) {
  <mwp-report-builder-templates [templates]="templates" (emitCancel)="reset()" (emitSave)="submitPanel($event)" />
}
@if (wizardPanel == reportWizardPanel.parameters) {
  <mwp-report-builder-parameters [reportWizardParameters]="reportWizardParameters" (emitCancel)="reset()" (emitSave)="submitPanel($event)" />
}
@if (wizardPanel == reportWizardPanel.detail) {
  <mwp-report-builder-detail [reportWizardDetail]="reportWizardDetail" (emitCancel)="reset()" (emitSave)="submitPanel($event)" />
}
@if (wizardPanel == reportWizardPanel.summary) {
  <mwp-report-builder-summary [reportSummaryPayload]="reportSummaryPayload" (emitCancel)="reset()" (emitSave)="submitPanel($event)" />
}